export default class PublicacaoInput {

    constructor () {
      this.id = null
      this.titulo = null
      this.texto = null
      this.data = new Date().toISOString().substr(0, 10)
      this.ativa = 'S'
      this.publicado = 'S'
      this.cor_fundo = null
      this.ordem = null
      this.grupo_id = null
      this.autor_id = null
      this.editorial_id = null
      this.imagem = []
    }

    static initGrupo(grupo_id) {
        var c = new PublicacaoInput()
        c.grupo_id = grupo_id
        return c
    }
  }
